// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3PIyQ","content":"LoadingAlert_content__2heG7"};